import CmsComponent from "@/helpers/editor/components/CmsComponent.js";
import CompatibilityHelper from "@/helpers/CompatibilityHelper.js";

export default class CmsComponentBorder extends CmsComponent {
    type = `border`

    get autoGenerateId() {
        return false;
    }

    get allowMediaQuery() {
        return true;
    }

    constructor(data) {
        super(data);

        if (!data) {
            this.color = `#cccccc`;
            this.width = `none`;
            this.style = `solid`;
        } else {
            this.color = CompatibilityHelper.checkColor(this.color);
        }
    }
}
